export default "__VITE_ASSET__sgDXlT4C__"